// extracted by mini-css-extract-plugin
export default {"socialContainer":"_2AWbp","arrow":"_30unS","icon":"_3TwLA","mobileOnly":"_23mBs","innerIcon":"WMkx-"};